import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useField } from 'react-final-form';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import City from '../../../../../City/City';
import Country from '../../../../../Country/Country';
import InfoPrompt from '../../../../../InfoPrompt/InfoPrompt';
import PostalCode from '../../../../../PostalCode/PostalCode';
import State from '../Fields/components/StateField';
import StreetAddressExtendedDE from '../StreetAddressExtendedDE/StreetAddressExtendedDE';

import {
  TXTCLI_Country_canXt_be_changed,
  TXTWCL_You_must_be_a_resident_of_this_ELL
} from './FieldsDE.messages.json';
import { info, infoText, inputText, manual, manualHidden, manualVisible } from './FieldsDE.scss';

interface Props {
  addressSearchFeature: boolean;
  formVisible: boolean;
}

const MAX_LENGTH = 85;

const FieldsDE: React.FC<Props> = ({ addressSearchFeature, formVisible }) => {
  const signupCountry = useSelector(select.account.getCountry);

  const {
    input: { value: country }
  } = useField('country', { initialValue: signupCountry });

  return (
    <fieldset
      className={classNames(
        manual,
        formVisible || !addressSearchFeature ? manualVisible : manualHidden
      )}
      data-testid="address-form"
    >
      <Country
        country={country}
        fieldName="country"
        isRmfFlow
        labelClassName={info}
        labelContent={
          <InfoPrompt
            title={{
              translation: TXTCLI_Country_canXt_be_changed
            }}
          >
            <p className={infoText}>
              <Translation {...TXTWCL_You_must_be_a_resident_of_this_ELL} />
            </p>
          </InfoPrompt>
        }
        className={inputText}
      />
      <section>
        <StreetAddressExtendedDE />
        <City fieldName="city" maxLength={MAX_LENGTH} />
        <State country={country} fieldName="state" />
        <PostalCode country={country} fieldName="zip" />
      </section>
    </fieldset>
  );
};

export default FieldsDE;
